import Calendar from './src/';
export default Calendar;



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/index.js